module.exports = __webpack_public_path__ + "assets/img/en-4d0360da.png";